export const css = {
	root: '_1OCFC8lG',
	calendar: 'wDiVmIYS',
	valid: '_3GrJPR05',
	invalid: '_36gdTKPi',
	' _key': 'base-widgets/date-input/date-input'
};

export default css;
